import template from './dashboard.html';
import './dashboard.less';

class DashboardController {
    constructor($scope, UtilService, DataApiService, $state) {
        'ngInject';
        this.$scope = $scope
        this.UtilService = UtilService
        this.DataApiService = DataApiService
        this.$state = $state
    }

    $onInit() {
        let that = this;
        that.tabNames = ["Home", "Med Calendars"]
        that.currentTab = "Home"
        that.isLoading = true

        if (that.$state.params.expired) {
            that.expired = true;
        }

        that.DataApiService.getPatientProfiles().then((result) => {
            that.patients = result.patients
            if (that.$state.params.preselectedPatient) {
                const preselected = that.$state.params.preselectedPatient
                that.selectedPatient = result.patients.find(p => p.patient.firstName === preselected.firstName
                    && p.patient.middleInitial === preselected.middleInitial
                    && p.patient.lastName === preselected.lastName)

                if (that.selectedPatient === undefined) {
                    that.selectedPatient = result.patients[0]
                }
            } else {
                that.selectedPatient = result.patients[0]
            }


            that.isLoading = false
        })

        if (that.$state.params.isFromPatientConnect) {
            that.showPopup = true
        }

        const smallScreenQuery = window.matchMedia("(max-width: 768px)")
        that.isSmallScreen = smallScreenQuery.matches
        smallScreenQuery.addEventListener("change", () => {
            that.isSmallScreen = smallScreenQuery.matches
        })

        // watch selectedPatient change and update expired status, tab selects
        this.$scope.$watch(() => that.selectedPatient, function(newVal, oldVal) {
            if (newVal && newVal !== oldVal) {
                if(newVal.schedule) {
                    that.expired = newVal.schedule && newVal.schedule.expiredAt && new Date(newVal.schedule.expiredAt) < new Date();
                }
            }
        }, true);
    }

    onTabSelected(tabName) {
        this.currentTab = tabName
    }

    onPopupClose() {
        this.showPopup = false
    }
}

export const DashboardComponent = {
    name: 'mmsDashboard',
    component: {
        template: template,
        controller: DashboardController,
        bindings: {
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/dashboard.component.js